$(function () {
    $(".mega-dropdown > a").click(function (e) {
        console.log('CLICK');

        let menu = $(this).siblings('.dropdown-menu');

        $('.mega-dropdown .dropdown-menu.show').not(menu).removeClass('show');
        menu.toggleClass('show');
    });

    $('body').on('click', function (e) {
        if (!$('.mega-dropdown').is(e.target)
            && $('.mega-dropdown').has(e.target).length === 0
            && $('.show').has(e.target).length === 0
        ) {
            $('.mega-dropdown').find('.dropdown-menu').removeClass('show');
        }
    });
});
